import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';

import { TransactionsSearchQuery } from '../Transactions/hooks/useTransactionsSearch/transactionsSearch.gql';

interface useIsNewAccountCheckingBankProps {
  companyUserId: string | undefined;
  transactions: TransactionsSearchQuery | undefined;
}

const useIsNewAccountCheckingBank = ({
  companyUserId,
  transactions,
}: useIsNewAccountCheckingBankProps) => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  const hasPastTransactions =
    !!transactions?.viewer.company.transactionsSearch.edges.length;
  const isAccessingEmployeeTransactions = !!companyUserId;

  const isNewAccountCheckingBank =
    transactions &&
    !hasPastTransactions &&
    !isAccessingEmployeeTransactions &&
    canAccessFeature({ name: FeatureName.BankTransactions }) &&
    canAccessFeature({ name: FeatureName.Invoicing });

  return { isNewAccountCheckingBank: !!isNewAccountCheckingBank };
};

export default useIsNewAccountCheckingBank;
